import { Component, OnInit, OnDestroy,  Directive, EventEmitter, Input,Output, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import { UsrmgtService } from 'src/app/usermgt/services/usrmgt.service';
import { ToastrService } from 'ngx-toastr';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { HelperService } from 'src/app/common-service/helper.service';
import { MDMServicesService } from 'src/app/mdm/services/mdmServices.service';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent implements OnInit {

      subscribe: Subject<any> = new Subject<any>();
      paymentForm: FormGroup;
      submitted = false;
      initiatePaymentReq = false;
      initiatePaymentEncyReq = false;
      EditableMode: boolean = false;
      initiatePaymentReqText = "";
      initiatePaymentEncyReqText = "";
      countryMstrId:any;
      productOption: any[];
      paymentObj=
      {

          name: '',
          phoneNo: '',
          emailId: '',
          product: '',
          amount: '',
      }
  constructor(public fb: FormBuilder,public router: Router, public usrmgtService: UsrmgtService, public helper: HelperService,
    public mdmService: MDMServicesService,public route: ActivatedRoute,public tostar: ToastrService) { }

  ngOnInit(): void {

    this.productOption = ["Eligibility","PTR","FQSR"];
    this.paymentForm = this.fb.group({
     name: ['', Validators.required],
     phoneNo: ['', Validators.required],
     emailId: ['', Validators.required],
     product: ['', Validators.required],
     amount: ['', Validators.required]
    });


  }

initiatePayment(){

  this.submitted=true;
  if (this.paymentForm.valid) {
    
            this.mdmService.initiatePaymentDetails(this.paymentObj).subscribe((data: any) => {
          if (data !== null) {
            // this.tostar.success('', 'success', {
            //   timeOut: 4000
            // });
           // alert("Payment Request Success");
            this.initiatePaymentReq = true;
            this.initiatePaymentReqText = data.paymentOriginalResponseUrl;
            this.initiatePaymentEncyReq = true;
            this.initiatePaymentEncyReqText = data.paymentEncyResponseUrl;
          }
        }, error => {
          // this.tostar.error(error.error, 'Error', {
          //     timeOut: 5000
          //   });
          alert("Error");
        });
      


    }

  }

keyPressNumberAndplus(event: any) {
    const pattern = /[0-9+]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
   }
}

keyPressName(event: any) {
    const pattern = /[A-Z,a-z ]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

reset(){
  this.paymentObj={

                  name: '',
                  phoneNo: '',
                  emailId: '',
                  product: '',
                  amount: '',
              };
          this.initiatePaymentReqText = "";
          this.initiatePaymentReq = false;
}

 back(){
    this.router.navigate(['/login']);
  }
}
